// src/services/trendingService.js

// Mock data from your API response

  // In a real app, this would be an API call
//   export const fetchTrendingData = async (timeframe) => {
//     // Simulate API request delay
//     await new Promise(resolve => setTimeout(resolve, 500));
    
//     // In a real app, you would make the API call here with the timeframe
//     // For now, return the mock data
//     return mockApiResponse;
//   };


  export const fetchTrendingData = async (timeframe) => {
    try {
      const response = await fetch(
        `https://lmkbvv7mzl.execute-api.ap-southeast-2.amazonaws.com/v2/trend`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ timeframe: timeframe, 

           }),
        }
      );
  
      if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  };